<template>
  <div>
    <Modal v-if="isOpen" :status="isOpen" @close="handleMesage(4)">
      <h2>System Message</h2>
      <p v-if="isCytologist">Please select an option below.</p>
      <div class="d-flex justify-evenly gap-2">
        <button
          @click="() => handleMesage(1)"
          v-if="(isScreener || isReviewer) && isAvailableForRescreen"
          class="btn btn-primary"
        >
          Re-screen
        </button>
        <button @click="() => handleMesage(2)" v-if="canReview" class="btn btn-primary">
          Review
        </button>
        <button @click="() => handleMesage(2)" v-if="canReview" class="btn btn-primary">
          Review
        </button>
        <button @click="() => toggleReReport()" v-if="reReportPopup" class="btn btn-warning">
          Re-Report
        </button>
        <button @click="() => handleMesage(3)" class="btn btn-primary">View</button>
        <button @click="() => handleMesage(4)" class="btn btn-primary">Cancel</button>
      </div>
    </Modal>
    <Modal v-else :status="reReportPopup" @close="toggleReReport">
      <re-report-popup class="overflow-hidden" />
    </Modal>
  </div>
</template>

<script>
import { CytReviewTypeEnum } from "@/modules/enums";
import { mapGetters, mapState } from "vuex";
import { CaseStatusEnum } from "../../modules/enums";

export default {
  name: "CytologySystemPrompt",
  props: {
    canReview: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ReReportPopup: () => import("../ReReportPopup.vue"),
    Modal: () => import("@/components/common/Modal.vue")
  },

  methods: {
    handleMesage(option) {
      this.$emit("action", option);
    },
    toggleReReport() {
      this.$emit("close");
      this.$store.commit("accessionStore/setReReportPopup", !this.reReportPopup);
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      labSettings: state => state.labSettings,
      sessionDetails: state => state.sessionDetails,
      caseStatus: state => state.accessionStore.caseHeader?.status,
      hasCytologyPrompted: state => state.sessionDetails.cytologyPrompted,
      isSessionRescreen: state => state.sessionDetails.reScreen,
      reReportPopup: state => state.accessionStore.reReportPopup
    }),
    ...mapGetters(["cytReviewTypeId"]),
    isCaseComplete() {
      const completeStatuses = [
        CaseStatusEnum.Reported,
        CaseStatusEnum.ReReleased,
        CaseStatusEnum.ReportedPrelim,
        CaseStatusEnum.CytResultComplete
      ];
      if (this.isCaseScreener && this.caseStatus === CaseStatusEnum.CytResultComplete) {
        return false;
      }
      return completeStatuses.includes(this.caseStatus);
    },

    isScreener() {
      return (
        this.cytReviewTypeId === CytReviewTypeEnum.Screener ||
        this.cytReviewTypeId === CytReviewTypeEnum.Pathologist
      );
    },
    isAvailableForRescreen() {
      //! These statuses are reached only when a screening has already happened.
      const completeStatuses = [
        CaseStatusEnum.CytResultComplete,
        CaseStatusEnum.Reported,
        CaseStatusEnum.CytAwaitingPathologist,
        CaseStatusEnum.CytAwaitingReviewer
      ];
      return completeStatuses.includes(this.caseStatus);
    },

    isReviewer() {
      return (
        this.cytReviewTypeId === CytReviewTypeEnum.Reviewer ||
        this.cytReviewTypeId === CytReviewTypeEnum.Pathologist
      );
    }
  },
  // User role checking
  isCytologist() {
    const cytologistRoles = [
      CytReviewTypeEnum.Screener,
      CytReviewTypeEnum.Reviewer,
      CytReviewTypeEnum.Pathologist
    ];

    return cytologistRoles.includes(this.cytReviewTypeId);
  }
};
</script>

<style lang="scss" scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
